import { create } from 'zustand';

import { type AnyModalStore, createModalStore, registerModalOccupant } from '@/shared/lib/modal';

export const useAcquisitionSurveyStore = createModalStore();

type AcquisitionSurveyRequestState = {
  clear: () => void;
  isRequested: boolean;
  request: () => void;
};

export const useAcquisitionSurveyRequestStore = create<AcquisitionSurveyRequestState>((set) => ({
  clear: () => set({ isRequested: false }),
  isRequested: false,
  request: () => set({ isRequested: true }),
}));

export const acquisitionSurveyRequestOccupant: AnyModalStore = {
  subscribe: (listener) =>
    useAcquisitionSurveyRequestStore.subscribe((state, previous) =>
      listener({ isOpen: state.isRequested }, { isOpen: previous.isRequested }),
    ),
  getState: () => {
    const { clear, isRequested } = useAcquisitionSurveyRequestStore.getState();

    return { close: clear, isOpen: isRequested };
  },
};

registerModalOccupant(acquisitionSurveyRequestOccupant);

export const requestAcquisitionSurvey = () => useAcquisitionSurveyRequestStore.getState().request();

export const resetAcquisitionSurvey = () => {
  useAcquisitionSurveyStore.getState().close();
  useAcquisitionSurveyRequestStore.getState().clear();
};
